import firebase from 'firebase/app'

import moment from 'moment'
import isEmpty from 'lodash/isEmpty'

export const PLANS_COUNT_BASIC = 1
export const PLANS_COUNT_STARTER = 6
export const PLANS_COUNT_PREMIUM = Infinity
export const USER_STATUS_BASIC = 'basic'
export const USER_STATUS_STARTER = 'starter'
export const USER_STATUS_PREMIUM = 'premium'
export const USER_STATUS_PARKED = 'parked'

export class User {
  constructor(user) {
    this.id = firebase.auth().currentUser.uid
    if (user) {
      this.status = user.status
      this.statusValidity = user.statusValidity
      this.stripeCustomerId = user.stripeCustomerId
      this.stripeSubscriptionId = user.stripeSubscriptionId
      this.plansLimitCount = user.plansLimitCount
      this.company = user.company
      this.address = user.address
      this.vat = user.vat
      this.modules = user.modules
    }
  }

  getStatusPlanLimit = () => {
    if (this.plansLimitCount && this.plansLimitCount > 0) {
      return this.plansLimitCount
    }
    if (isEmpty(this.status)) {
      return PLANS_COUNT_BASIC
    }
    switch (this.status) {
      case USER_STATUS_STARTER:
        return PLANS_COUNT_STARTER
      case USER_STATUS_PREMIUM:
        return PLANS_COUNT_PREMIUM
      default:
        return PLANS_COUNT_BASIC
    }
  }

  isStarterOrPremium = () => {
    return [USER_STATUS_PREMIUM, USER_STATUS_STARTER].includes(this.status)
  }

  isUserParked = () => {
    return USER_STATUS_PARKED === this.status
  }

  isTrial = () => {
    return USER_STATUS_BASIC && this.stripeSubscriptionId === undefined
  }

  getTrialRemainingDays = () => {
    const statusValidity = moment(this.statusValidity ? this.statusValidity.toDate() : new Date())
    return statusValidity.diff(new Date(), 'days')
  }

  hasOutdatedSubscription = () => {
    return this.statusValidity && new Date() > this.statusValidity.toDate()
  }

  canUpgradeTo = status => {
    if (this.isTrial()) {
      return true
    }

    switch (this.status) {
      case USER_STATUS_BASIC:
        if (this.hasOutdatedSubscription()) {
          return true
        } else {
          switch (status) {
            case USER_STATUS_STARTER:
            case USER_STATUS_PREMIUM:
            case USER_STATUS_PARKED:
              return true
            default:
              return false
          }
        }
      case USER_STATUS_STARTER:
        if (this.hasOutdatedSubscription()) {
          switch (status) {
            case USER_STATUS_STARTER:
            case USER_STATUS_PREMIUM:
            case USER_STATUS_PARKED:
              return true
            default:
              return false
          }
        } else {
          return status === USER_STATUS_PREMIUM || status === USER_STATUS_PARKED
        }
      case USER_STATUS_PREMIUM:
        if (this.hasOutdatedSubscription()) {
          return status === USER_STATUS_PREMIUM
        } else {
          throw Error(
            'We should not be able to display the modal if we are premium with a valid subscription'
          )
        }
      case USER_STATUS_PARKED:
        return true
      default:
        return false
    }
  }
}
